import { iPermissionFields } from "./PermissionSection";
import { components } from "@apiSchema";

export enum ChainType {
    Restaurant = 1,
    Supermarket = 2,
    CStore = 3,
}

export type API__FPCHainDataExtended = components["schemas"]["FPChainData"] & {
    chainType: ChainType;
}

export interface iBrandData extends iPermissionFields {
    data: API__FPCHainDataExtended;
}

export class FPChainData implements API__FPCHainDataExtended {
    static defaultData: API__FPCHainDataExtended = {
        headerData: {
            circles: [],
            nps: 0,
            detractor: 0,
            passive: 0,
            promoter: 0,
        },
        situationAssessmentData: {
            strengths: [],
            weakness: [],
        },
        brandFunnelData: [],
        customerExperience: [],
        foodAndBeverageQuality: [],
        valueProposition: [],
        chainType: ChainType.Restaurant,
    };

    // Shown blurred behind the permission overlay — the API sends no data when the user has no access.
    static readonly fakeData: API__FPCHainDataExtended = {
        headerData: {
            circles: [
                { title: 'Food', chainValue: 52, averageValue: 48 },
                { title: 'Experience', chainValue: 47, averageValue: 45 },
                { title: 'Service', chainValue: 55, averageValue: 50 },
                { title: 'Value', chainValue: 41, averageValue: 44 },
            ],
            nps: 12,
            detractor: 24,
            passive: 40,
            promoter: 36,
        },
        situationAssessmentData: {
            strengths: [
                { name: 'Value for the dollar' },
                { name: 'Combo meals' },
                { name: 'Affordability' },
                { name: 'Consistent experience every time' },
                { name: 'Good for kids' },
                { name: 'Portion sizes' },
            ],
            weakness: [
                { name: 'Freshness' },
                { name: 'Premium ingredients' },
                { name: 'Décor / ambiance' },
                { name: 'High quality food' },
                { name: 'Taste' },
                { name: 'Offers a unique experience' },
            ],
        },
        brandFunnelData: [
            { name: 'Aware', value: 95 },
            { name: 'Consider', value: 80 },
            { name: 'Try', value: 70 },
            { name: 'Loyal', value: 55 },
            { name: 'Recommend', value: 30 },
        ],
        customerExperience: [
            { name: 'Cleanliness', value: 48 },
            { name: 'Consistent experience every time', value: 45 },
            { name: 'Good for kids', value: 42 },
            { name: 'Takeout food quality', value: 40 },
            { name: 'Delivery food quality', value: 36 },
            { name: 'Décor / ambiance', value: 33 },
        ],
        valueProposition: [
            { name: 'Value for the dollar', value: 50 },
            { name: 'Affordability', value: 47 },
            { name: 'Discounts / special deals', value: 43 },
            { name: 'Portion sizes', value: 39 },
            { name: 'Combo meals', value: 35 },
        ],
        foodAndBeverageQuality: [
            { name: 'Taste', value: 46 },
            { name: 'Freshness', value: 41 },
            { name: 'High quality food', value: 38 },
            { name: 'Premium ingredients', value: 32 },
            { name: 'Attractively presented', value: 30 },
        ],
        chainType: ChainType.Restaurant,
    };

    headerData = FPChainData.defaultData.headerData;
    situationAssessmentData = FPChainData.defaultData.situationAssessmentData;
    brandFunnelData = FPChainData.defaultData.brandFunnelData;
    customerExperience = FPChainData.defaultData.customerExperience;
    foodAndBeverageQuality = FPChainData.defaultData.foodAndBeverageQuality;
    valueProposition = FPChainData.defaultData.valueProposition;
    chainType = FPChainData.defaultData.chainType;
}
